/**
 * FseMarkWeb — the FSE ticker badge (leaf square + "FSE" monogram + mango
 * upward chart line), rendered as an inline SVG for the web auth surfaces.
 *
 * Mirrors `Documentation/Claude design files/assets/fse-mark.svg` and the
 * mobile `FseMark` (`packages/ui/src/mobile/components/FseMark.tsx`). The web
 * `@fse/ui` kit does not yet export an FseMark, and Builder C may not edit the
 * kit (kit owner), so this co-located component is the web equivalent used by
 * the signup Welcome hero. Colours come from the `@fse/ui` brand tokens (no
 * hardcoded hex) and the badge stroke (ink) adapts to the colour mode so the
 * mark stays legible on both light and dark.
 */
import { brand, useColorMode, mdSysColor } from '@fse/ui';

export interface FseMarkWebProps {
  /** Square size in px. Default 64. */
  size?: number;
  /** Override the badge stroke (ink) colour; defaults to mode-aware onSurface. */
  inkColor?: string;
}

export function FseMarkWeb({ size = 64, inkColor }: FseMarkWebProps) {
  const { mode } = useColorMode();
  const ink = inkColor ?? mdSysColor[mode].onSurface;
  return (
    <svg width={size} height={size} viewBox="0 0 64 64" fill="none" aria-hidden="true">
      <rect
        x={2}
        y={2}
        width={60}
        height={60}
        rx={14}
        fill={brand.leaf[700]}
        stroke={ink}
        strokeWidth={2.5}
      />
      <text
        x={32}
        y={38}
        fontFamily='"Bricolage Grotesque Variable", "Bricolage Grotesque", sans-serif'
        fontWeight={800}
        fontSize={22}
        letterSpacing="-0.5"
        fill="#FFFFFF"
        textAnchor="middle"
      >
        FSE
      </text>
      <path
        d="M 14 50 L 22 44 L 30 47 L 42 38 L 50 41"
        stroke={brand.mango[500]}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M 46 38 L 50 41 L 47 45"
        stroke={brand.mango[500]}
        strokeWidth={2.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
